export default "__VITE_ASSET__BuifZgy3__"